import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { renderMarkdown } from '~/functions/markdown'


export default /*#__PURE__*/_defineComponent({
  __name: 'GhgRecurringImpactGuidance',
  setup(__props) {

const showExample = ref(false)

return { __sfc: true,showExample, renderMarkdown }
}

})